import styled from './newpedido.module.css';
import Menu from '../../components/Menu';
import Header from '../../components/Header';
import {BiSave,BiX} from 'react-icons/bi';
import {Link} from 'react-router-dom';
import ListaProduto from '../../components/ListaProdutos';



function NewPedido() {
    return (
        <div className={styled.page}>
            <Menu menu="pedidos" />
            <div className={styled.container}>
                <Header page="Novo Pedido" />
                <div className={styled.content}>
                    <div className={styled.card}>
                        <div className={styled.cardheader}>
                            <div className={styled.cardtitle}>
                                <a>Produtos</a>
                                <div className={styled.cardtitleline}></div>
                            </div>
                            <Link to="/Pedidos" className={styled.cardbtnnew2}>
                               {window.screen.availWidth >= 1024 ? <BiX size={20} className={styled.btncan}/> : <BiX size={35} className={styled.btncan}/>} 
                               
                               {window.screen.availWidth >= 1024 ? <a>Cancelar Pedido</a> : <a></a>}
                            </Link>
                            <div className={styled.cardbtnnew}>
                               {window.screen.availWidth >= 1024 ? <BiSave size={20} className={styled.btnsave}/> : <BiSave size={35} className={styled.btnsave}/>}
                               
                               {window.screen.availWidth >= 1024 ? <a>Resumo Pedido</a> : <a></a>}
                            </div>
                        </div>
                        <div className={styled.cardcontent}>
                            <div className={styled.apppedidos}>
                                <div className={styled.apppedidosframe101}>
                                    <div className={styled.applistapedidos}>
                                        <div className={styled.applistapedidos100}>
                                            <div className={styled.applistapedidos99}>
                                               <ListaProduto/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}


export default NewPedido;